
/**
 * esto es para los empleados
 */

import CardContenedor from "../components/CardContenedor";
import useHistorialSalidas from "../hooks/useHistorialSalidas";
import Table from "react-bootstrap/Table";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";
import { Volver } from '../components/Volver'


export default function HistorialSalidas() {

    const { listaHistorial, traerExcel } = useHistorialSalidas({})
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    if (objLogueado.permitido !== "empleado") {
        window.location = "/"
        return (<></>)
    }

    const TextPermisos = () => {
        if (listaHistorial.length === 0) {
            return <p className="lead py-2">No hay historial de salidas</p>
        } else if (listaHistorial.length === 1) {
            return <p className="lead py-2">Mostrando 1 permiso</p>
        } else {
            return <p className="lead py-2">Mostrando {listaHistorial.length} permisos</p>
        }
    }

    return (
        <CardContenedor>

            <Volver />

            <TextPermisos/>


            <div style={{ overflowX: 'scroll' }}>
                <Table hover>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Área de adscripción</th>
                            <th>Motivo</th>
                            <th>Hora salida</th>
							<th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listaHistorial.map(e => (
                            <tr key={e.id}>
                                <td>{e.fecha}</td>
                                <td>{e.areas_adscripcion}</td>
                                <td>{e.motivo}</td>
                                <td>{e.hora_salida}</td>
								<td>
									<button className="btn btn-primary btn-block" onClick={ () => traerExcel(e.id) }>
										Imprimir
                                    </button>
								</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

        </CardContenedor>
    )
}
